<div class="login ">
  <div class="main-container" *ngIf="showPage">
    <div class="login-container">
      <div class="login__form-side">
        <div class="login-image">
          <img src="./assets/images/logos/erx-logo.svg" alt="erx logo" class="img-fluid" 
            style="width: 90px; max-width: none;">
        </div>
        <div class="login-form">
          <h5>SET PASSWORD <br /> <span class="updated-name">for <span>{{nameOfUser}}</span></span>
          </h5>
          <form>
            <div class="form-group password">
              <div class="custom-tooltip tooltip-right" style="width: 200px;right: 290px;top : -30px" *ngIf="!(submitClicked && !NewPassword) && (validationMssgArr.length && NewPassword)" role="tooltip">
                <div class="arrow"></div>
                <div class="tooltip-inner">
                  {{validationMssg}}
                </div>
              </div>
              <input type="password" autocomplete="off" class="form-control-login " [class.is-invalid]="(validationMssgArr.length && NewPassword) || (submitClicked && !NewPassword)" required id="password" [(ngModel)]="NewPassword"
                value="" (ngModelChange)="validatePassword()" appPreventFirstSpace #passwordInput>
              <label for="password" class="input-label"> ENTER NEW PASSWORD</label>
              <div class="invalid-feedback "*ngIf="(submitClicked && !NewPassword)" >
                This field is required
              </div>
              <div class="pw-icon show-password" [ngClass]="password1Class" (click)="showPassword(true)"></div>
            </div>
            <div class="form-group password">
              <input type="password" autocomplete="off" class="form-control-login " required id="password1" [(ngModel)]="RePassword" [class.is-invalid]="(submitClicked && !RePassword) || (submitClicked && RePassword!==NewPassword)"
                value="" appPreventFirstSpace #ReInput>
              <label for="password1" class="input-label">CONFIRM NEW PASSWORD</label>
              <div class="invalid-feedback "*ngIf="(submitClicked && !RePassword)" >
                This field is required
              </div>
              <div class="invalid-feedback "*ngIf="!(submitClicked && !RePassword) && (submitClicked && RePassword!==NewPassword)" >
                new paasword and confirm password are not same
              </div>
              <div class="pw-icon show-password" [ngClass]="password2Class" (click)="showPassword(false)"></div>
            </div>
            <button type="submit" class="btn btn-darkblue" (click)="restSubmited()">Reset password</button>
          </form>
        </div>
      </div>
      <div class="login__img-side">
        <h1>
          Automate and integrate workflows to optimize efficiency
        </h1>
      </div>
    </div>
  </div>
  <div class="main-container" >
    <div class="container-fluid">
      <div class="row">
          <div class="col-12">
              <div class="no-data not-found-wrap">
                  <div class="d-flex align-items-center flex-column">
                      <img src="assets/images/icons/404.svg" alt="">
                      <h1 class="not-found-text">404</h1>
                      <h5 class="not-found-sm-text">Page not Found!</h5>
                      <p>The page you are looking for doesn’t exist!</p>
                  </div>
              </div>
          </div>
      </div>
  </div>
  </div>
</div>
